function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export default function (props, propName, componentName, location) {
  if (!(props[propName] instanceof RegExp)) {
    var propType = _typeof(props[propName]);

    return new Error('Invalid ' + location + ' `' + propName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `RegExp`.'));
  }

  return undefined;
}